import React, {Fragment} from "react";
import {ReferenceArea} from "recharts";
import {LEVEL_COLORS} from "./levelColors";

export const GreaterThresholdMarker = ({domains, threshold}) => {
  const [, maxValue] = domains;
  const {level, value} = threshold;
  const color = LEVEL_COLORS[level.toLowerCase()];

  return (
    <Fragment>
      {(value || value === 0) && (
        <ReferenceArea
          fill={color}
          ifOverflow="hidden"
          stroke="none"
          y1={value}
          // Multiply by 2 because sometimes the max value does not touch the top of the chart
          y2={maxValue * 2}
        />
      )}
    </Fragment>
  );
};
